import React from 'react';
import Grid from '@material-ui/core/Grid';

export default function PointSelectionTextBelow(props) {
  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid item>
        <div style={{ width: '88px' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <span>{props.firstText}</span>
            </Grid>
          </Grid>
        </div>
      </Grid>

      <Grid item>
        <div style={{ width: '22px', height: '1px' }} />
      </Grid>

      <Grid item>
        <div style={{ width: '110px' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <span>{props.secondText}</span>
            </Grid>
          </Grid>
        </div>
      </Grid>

      <Grid item>
        <div style={{ width: '22px', height: '1px' }} />
      </Grid>

      <Grid item>
        <div style={{ width: '88px' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <span>{props.thirdText}</span>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}
